// extracted by mini-css-extract-plugin
export default {"animatedContainer":"animated-container_animatedContainer__K4ej2","slideLeftToRight":"animated-container_slideLeftToRight__ueut+"};